import { render, staticRenderFns } from "./ProjectFlightEdit.vue?vue&type=template&id=5aa1bcc4&"
import script from "./ProjectFlightEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectFlightEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports